const recommendationsTypes = {
  FETCH_START: "FETCH_RECOMMENDATIONS_START",
  FETCH_SUCCESS: "FETCH_RECOMMENDATIONS_SUCCESS",
  FETCH_FAILURE: "FETCH_RECOMMENDATIONS_FAILURE",
  DISMISS: "DISMISS_RECOMMENDATION",
  MARK_VIEWED: "MARK_RECOMMENDATION_VIEWED",
};

export default recommendationsTypes;
